import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import { deleteAllSponsors } from "ActionsSponsors";

class SponsorDelete extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  deleteAllSponsors(e) {
    confirmAlert({
      title: LocaleStrings.sponsor_title_delete,
      message: LocaleStrings.sponsor_text_are_you_sure_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteAllSponsors(this.props.session, (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.finishOperationsCallback();
                this.props.showSuccess(LocaleStrings.sponsor_message_deleted);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    return (
      <div className="dropdown-btn-container">
        <Button
          className="btn-custom-blue schedule-add-button"
          onClick={this.deleteAllSponsors.bind(this)}
        >
          <i
            className="fa fa-trash"
            aria-hidden="true"
            style={{ paddingRight: 10, paddingBottom: 3 }}
          ></i>
          {LocaleStrings.sponsor_deleteall}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  deleteAllSponsors,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "SponsorDeleteForm",
    enableReinitialize: true,
  })(SponsorDelete)
);
